import defaultTypes from './defaultTypes.js';
import defaultSystems from './defaultSystems.js';

const defaultConfig = {
    systems: defaultSystems,
    types: defaultTypes,
    noValueFallback: NaN
};

export default defaultConfig;